import axiosClient from '../configs/axios';


class PickupService {
    // Get list 
    async getPickupList(params) {
        try {
            const response = await axiosClient.get(
                `/pickup_entry/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addPickup(data) {
        try {
            const response = await axiosClient.post('/pickup_entry/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeletePickup(data) {
        try {
            const response = await axiosClient.put(`/pickup_entry/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new PickupService(); 